/**
 * Rótulo com a pergunta que a métrica responde, ao pousar o ponteiro.
 *
 * O sublinhado pontilhado é a convenção de "tem explicação aqui": sem ele, ninguém sabe
 * que vale a pena parar o ponteiro sobre o rótulo.
 */

import type { ReactNode } from "react";
import { Tooltip } from "@cloudflare/kumo";

/** Entradas do rótulo explicativo. */
interface HintLabelProps {
  readonly hint: string;
  readonly children: ReactNode;
}

/** Rótulo sublinhado que mostra a explicação ao pousar o ponteiro ou focar. */
export function HintLabel({ hint, children }: HintLabelProps): React.ReactElement {
  return (
    <Tooltip
      content={hint}
      render={<span className="cursor-help border-b border-dotted border-kumo-line" tabIndex={0} />}
    >
      {children}
    </Tooltip>
  );
}
